// Import services & utilities
import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { IInvitedUsersResponse } from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";

/**
 * Async thunk to fetch invited users by form ID
 */
export const fetchSurveyFormInvitedEmployeesThunk = createServiceAsyncThunk<
  IInvitedUsersResponse,
  number
>(
  ACTION_NAMES.FETCH_SURVEY_FORMS_INVITED_EMPLOYEES,
  (formId) => surveyFormsService.getInvitedUsersByFormId(formId),
  ERROR_MESSAGES.FETCH_SURVEY_FORMS_INVITED_EMPLOYEES
);

/**
 * Slice for invited users
 */
const surveyFormInvitedEmployeesSlice = createGenericSlice<
  IInvitedUsersResponse,
  number
>(
  SLICE_NAMES.SURVEY_FORMS_INVITED_EMPLOYEES,
  fetchSurveyFormInvitedEmployeesThunk
);

export const {
  clearError: clearSurveyFormInvitedEmployeeError,
  clearSuccessMessage: clearSurveyFormInvitedEmployeesSuccess,
} = surveyFormInvitedEmployeesSlice.actions;

export default surveyFormInvitedEmployeesSlice.reducer;
